import { Chat as OverrideChat } from "../overrides/chat";

const chatTrigger = el => {
  window.orbit.chatInstance = new OverrideChat(el);
};

window.orbit = window.orbit || {};
window.orbit.chat = chatTrigger;
